var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.9381 9.40585C1.60021 9.40585 1.33264 9.41354 1.06506 9.40402C0.619257 9.38828 0.250605 9.22055 0.0909365 8.77634C-0.0653135 8.34165 0.0645694 7.95969 0.408319 7.65964C2.89953 5.48752 5.38976 3.31528 7.88635 1.14963C8.3551 0.742891 8.79016 0.741182 9.255 1.14816C11.7653 3.34604 14.2677 5.55295 16.776 7.75375C17.087 8.02695 17.1905 8.35397 17.0489 8.73715C16.8971 9.14938 16.5763 9.36887 16.1437 9.40073C15.8605 9.42148 15.5738 9.40463 15.2296 9.40463C15.2194 9.59836 15.2032 9.76462 15.2028 9.93124C15.2008 11.5354 15.2042 13.1396 15.2003 14.7437C15.1979 15.6103 14.7399 16.0719 13.8815 16.0789C13.2145 16.0843 12.547 16.0827 11.8795 16.0793C10.9816 16.0749 10.5231 15.6235 10.5196 14.7376C10.5157 13.9749 10.5226 13.2123 10.5172 12.4496C10.5118 11.6462 10.1818 11.3161 9.39221 11.3134C8.83605 11.3115 8.2799 11.3111 7.72424 11.3136C6.96496 11.3171 6.62951 11.6521 6.62267 12.4253C6.61584 13.2038 6.62463 13.9825 6.61975 14.761C6.61535 15.5975 6.15588 16.0693 5.33166 16.0785C4.63244 16.086 3.93322 16.0857 3.234 16.0785C2.40588 16.07 1.94201 15.6014 1.93908 14.768C1.93517 13.1789 1.9381 11.5899 1.9381 10.0009V9.40585Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.cc2ead3ea743475967fb0380fc86ab8d.svg";
export { ForwardRef as ReactComponent };